// extracted by mini-css-extract-plugin
module.exports = {"AwairLogo":"AwairLogo_AwairLogo__2uGx2"};